
import request from '@/utils/request'


export function temporaryToken(data) {
  return request({
    url: process.env.VUE_APP_API_temporaryToken+'/api/temporaryToken',
    method: 'post',
    data
  })
}
/**
 * 创建任务
 * @param {object} data 
 * @returns 
 */
export function createTask(data) {
  return request({
    url: process.env.VUE_APP_API+'/api/createUpscaleResTask',
    method: 'post',
    data
  })
}
/**
 * 获取结果
 * @param {object} data 
 * @returns 
 */
export function getResult(data) {
  return request({
    url: process.env.VUE_APP_API+'/api/getUpscaleResult',
    method: 'post',
    data
  })
}
/**
 * 下载图片
 * @param {object} data 
 * @returns 
 */
export function upscaleDownload(data) {
  return request({
    url: process.env.VUE_APP_API+'/api/upscaleDownload',
    method: 'post',
    data
  })
}


/**
 * 创建队列
 * @param {object} data 
 * @returns 
 */
export function upscaleSendQueue(data) {
  return request({
    url: process.env.VUE_APP_API+'/api/upscaleSendQueue',
    method: 'post',
    data
  })
}

/**
 * 判断是上传R2还是S3
 * @param {object} data
 * @returns
 * */ 
export function upscaleUploadType() {
  return request({
    url: process.env.VUE_APP_API_temporaryToken+'/v4/api/clouds',
    method: 'GET'
  })
}
